import React from "react";
import useHandleErrorPageView from "../../Hooks/useHandleErrorPageView";

const Error = (props) => {
  const [data] = useHandleErrorPageView(props.config);
  return <div>{data && data}</div>;
};

export default Error;
